<template>
  <div class="host vm-button-wrap">
    <button
      @click="$emit('click')"
      :type="type"
      :style="buttonStyle"
      class="vm-button-base"
      :class="this.classes"
    >
      <span class="vm-button-graient" :style="gradientStyle"></span>
      <span class="vm-button-overlay"></span>
      <span class="vm-button-wrapper">
        <slot />
      </span>
    </button>
  </div>
</template>

<script>
import { theme, offsetColor } from '@app/theme';
import parse from 'parse-color';

export default {
  data: () => ({ ...theme }),
  props: {
    type: {
      type: String,
      default: 'button'
    },
    vmButton: {
      type: Boolean,
      default: false
    },
    vmOutline: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'base'
    }
  },
  computed: {
    linearGradient() {
      const { rgb } = parse(this.primaryColor);
      const secondaryColor = offsetColor(rgb, 40);
      return `linear-gradient(90deg, ${this.primaryColor}, ${secondaryColor}`;
    },
    buttonStyle() {
      return {
        ...!this.vmOutline ? { background: this.linearGradient } : {},
        color: this.vmOutline ? this.primaryColor : '#ffffff',
      };
    },
    gradientStyle() {
      return { background: this.linearGradient };
    },
    classes: function() {
      return [
        `vm-${this.color}`,
        {
          'vm-outline-button': this.vmOutline
        }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
$primary-color: #8b31da;
$secondary-color: #6b40d6;
.vm-button-wrap {
  position: relative;
  z-index: 1;
}
.vm-button-base {
  display: flex;
  position: relative;
  text-transform: uppercase;
  font-weight: 500;
  height: 48px;
  border-radius: 24px;
  outline: none;
  box-sizing: border-box;
  align-items: center;
  padding: 0 24px;
  border: 0;
  background: linear-gradient(to right, $primary-color, $secondary-color);
  color: #fff;
  transition: opacity 300ms ease;
  overflow: visible;
}
.vm-button-base.vm-outline-button {
  border: 2px solid transparent;
  background: #fff;
  background-clip: padding-box;
  color: $primary-color;
}
.vm-button-base.vm-outline-button .vm-button-graient {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: linear-gradient(to right, $primary-color, $secondary-color);
  z-index: -1;
  margin: -2px;
  border-radius: 24px;
}
.vm-button-base .vm-button-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: transparent;
  border-radius: 24px;
  transition: background-color 300ms ease;
}
.vm-button-base.vm-outline-button .vm-button-overlay {
  margin: -2px;
}
.vm-button-base.vm-outline-button:hover .vm-button-overlay,
.vm-button-base:hover .vm-button-overlay {
  background-color: rgba(0, 0, 0, 0.1);
}
.vm-button-wrapper {
  font-size: 14px;
}
</style>
